import FooterRenderer from './FooterRenderer/FooterRenderer';
import footerRootQuery, {
    initialVariables as footerInitialVariables,
} from '../queries/footerRootQuery';

export { FooterRenderer, footerRootQuery, footerInitialVariables };
